"use client";

import { useId, useState } from "react";
import { MinusIcon, PlusIcon } from "../icons";
import styles from "./Faq.module.css";
import type { FaqItem as FaqItemContent } from "./Faq.types";

/** Une carte question / réponse dépliable (bouton accessible, région animée en hauteur). */
export function FaqItem({ item, defaultOpen = false }: { item: FaqItemContent; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen);
  const uid = useId();
  const buttonId = `${uid}-question`;
  const regionId = `${uid}-answer`;
  return (
    <li className={styles.item} data-open={open ? "true" : "false"}>
      <h3 className={styles.itemTitle}>
        <button type="button" id={buttonId} className={styles.question} aria-expanded={open} aria-controls={regionId} onClick={() => setOpen((value) => !value)}>
          <span className={styles.questionText}>{item.question}</span>
          <span className={styles.icon} aria-hidden="true">
            {open ? <MinusIcon /> : <PlusIcon />}
          </span>
        </button>
      </h3>
      <div id={regionId} role="region" aria-labelledby={buttonId} className={styles.answer}>
        <div className={styles.answerInner}>
          <div className={styles.answerContent}>{item.answer}</div>
        </div>
      </div>
    </li>
  );
}
